// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"kxfE9dxI9msb__hR"};